import React, { Component } from 'react';
import './../../assets/css/App.css';
import Highcharts from 'highcharts';
//import addFunnel from 'highcharts/modules/funnel';

class ChartWithHEader extends Component {
    state = {
        options: {
            chart: {
                type: 'column'
            },
            title: {
                text: this.props.chartTitle
            },
            xAxis: {
                categories: this.props.histogramChartCategoriesList
            },
            yAxis: [{
                title: {
                    text: 'Sign Ups, Shipments, Packages'
                },
                opposite: true
            },{
                title: {
                    text: 'Revenue'
                }
            }],
            tooltip: {
                histogramChartSeriesDataList5: this.props.histogramChartSeriesDataList5 != undefined ? this.props.histogramChartSeriesDataList5 : [] ,
                histogramChartSeriesDataList6: this.props.histogramChartSeriesDataList6 != undefined ? this.props.histogramChartSeriesDataList6 : [] ,
                formatter: function(chartObject) {
                    var s = [];
                    this.points.forEach(function(point, i) {
                        s.push('<span style="color:' + point.color + '; font-weight:bold;">'+ point.series.name +' : '+
                            point.y + '<span>');

  //                      console.log(point);
  //                     console.log(point.color);
                    });
                    // this code was used to custom print some values to the tooltip
/*                    var histogramChartSeriesDataList5 = chartObject.options.histogramChartSeriesDataList5;
                    var histogramChartSeriesDataList6 = chartObject.options.histogramChartSeriesDataList6;

                    if (histogramChartSeriesDataList5.length > 0) {
                        s.push('<span style="color:black;font-weight:bold;">'+ 'First Package' +' : '+
                            histogramChartSeriesDataList5[this.points[0].point.index]  + '<span>');
                    }

                    if (histogramChartSeriesDataList6.length > 0) {
                        s.push('<span style="color:black;font-weight:bold;">' + 'First Shipment' + ' : ' +
                            histogramChartSeriesDataList6[this.points[0].point.index] + '<span>');
                    }*/
/*                    console.log("*** s");
                    console.log(s);*/
                    return s.join('<br>');
                },
                shared: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [{
                name: 'Revenue',
                data: this.props.histogramChartSeriesDataList1,
                yAxis: 1
            },{
                name: 'Signups',
                data: this.props.histogramChartSeriesDataList2,
            },{
                name: 'Packages',
                data: this.props.histogramChartSeriesDataList3
            },{
                name: 'Shipments',
                data: this.props.histogramChartSeriesDataList4
            },{
                name: 'First Package',
                data: this.props.histogramChartSeriesDataList5
            },{
                name: 'First Shipment',
                data: this.props.histogramChartSeriesDataList6
            }
            ]
        }
    }
    componentDidMount() {
          this.chart = new Highcharts[this.props.type || "Chart"](
            this.refs.chart,
            this.state.options
        );

          console.log(this.chart);
    }

    componentWillUnmount() {
        this.chart.destroy();
    }

    updateChartConfig= () => {
        if (this.chart !== undefined) {
            this.chart.update({
                tooltip: {
                    histogramChartSeriesDataList5: this.props.histogramChartSeriesDataList5 != undefined ? this.props.histogramChartSeriesDataList5 : [] ,
                    histogramChartSeriesDataList6: this.props.histogramChartSeriesDataList6 != undefined ? this.props.histogramChartSeriesDataList6 : [] ,
                    formatter: function(chartObject) {
                        var s = [];
                        this.points.forEach(function(point, i) {
                            s.push('<span style="color:' + point.color + '; font-weight:bold;">'+ point.series.name +' : '+
                                point.y + '<span>');

                            //  console.log(point);
                            //  console.log(point.color);
                        });
                        var histogramChartSeriesDataList5 = chartObject.options.histogramChartSeriesDataList5;
                        var histogramChartSeriesDataList6 = chartObject.options.histogramChartSeriesDataList6;

                        if (histogramChartSeriesDataList5.length > 0) {
                            s.push('<span style="color:black;font-weight:bold;">'+ 'First Package' +' : '+
                                histogramChartSeriesDataList5[this.points[0].point.index]  + '<span>');
                        }

                        if (histogramChartSeriesDataList6.length > 0) {
                            s.push('<span style="color:black;font-weight:bold;">' + 'First Shipment' + ' : ' +
                                histogramChartSeriesDataList6[this.points[0].point.index] + '<span>');
                        }
                        // console.log("*** s");
                        // console.log(s);
                        return s.join('<br>');
                    },
                    shared: true
                },
            })

            this.chart.setTitle({text: this.props.chartTitle});
            this.chart.xAxis[0].categories = this.props.histogramChartCategoriesList;
            this.chart.series[0].setData(this.props.histogramChartSeriesDataList1, true);
            this.chart.series[1].setData(this.props.histogramChartSeriesDataList2, true);
            this.chart.series[2].setData(this.props.histogramChartSeriesDataList3, true);
            this.chart.series[3].setData(this.props.histogramChartSeriesDataList4, true);
            this.chart.series[4].setData(this.props.histogramChartSeriesDataList5, true);
        }
    }

    render() {
        // this code re renders the chart
        this.updateChartConfig();

        return (
            <div ref="chart"/>
        )
    }
}
export default ChartWithHEader;